import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Reviewstatuschange(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.REVIEWSTATUSCHANGE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.REVIEWSTATUSCHANGE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.REVIEWSTATUSCHANGE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}